<template>
    <div class="user">
        <template v-if="isAuthenticated">
            <div class="avatar">{{ initials }}</div>
            <div class="info">
                <div class="name">{{ name }}</div>
                <div v-if="subtitle" class="subtitle">{{ subtitle }}</div>
            </div>
            <button
                type="button"
                class="icon-btn"
                aria-label="Настройки"
                @click="$emit('open-settings')"
            >
                <ChatIcon name="settings" :size="16" />
            </button>
            <button
                type="button"
                class="icon-btn"
                aria-label="Выйти"
                @click="$emit('logout')"
            >
                <ChatIcon name="logout" :size="16" />
            </button>
        </template>
        <template v-else>
            <div class="guest">
                <div class="guest-title">Гостевой режим</div>
                <div class="guest-actions">
                    <router-link
                        to="/login"
                        class="guest-btn guest-btn--primary"
                        @click="onLoginClick"
                    >Войти</router-link>
                    <router-link to="/register-first-step" class="guest-btn">Регистрация</router-link>
                </div>
            </div>
        </template>
    </div>
</template>

<script setup>
import ChatIcon from '@/components/chat/icons/ChatIcon.vue'
import { reachGoal } from '@/utils/analytics'

defineProps({
    isAuthenticated: { type: Boolean, default: false },
    initials: { type: String, default: 'ГМ' },
    name: { type: String, default: 'Глеб М.' },
    subtitle: { type: String, default: '' },
})

defineEmits(['logout', 'open-settings'])

// Цель click_login (счётчик 110407517) — клик по кнопке «Войти» в сайдбаре чата.
function onLoginClick() {
    reachGoal('click_login')
}
</script>

<style scoped>
.user {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 10px;
    border-top: 1px solid #e0e0e0;
}

.avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #23282C;
    color: white;
    font-size: 11px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.info {
    flex: 1;
    min-width: 0;
}

.name {
    font-size: 12.5px;
    font-weight: 600;
    color: #23282C;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.subtitle {
    font-size: 10.5px;
    color: #888888;
    margin-top: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.icon-btn {
    background: transparent;
    border: 0;
    color: #888888;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    display: inline-flex;
    flex-shrink: 0;
}

.icon-btn:hover {
    color: #23282C;
    background: #e7e7e7;
}

.guest {
    width: 100%;
}

.guest-title {
    font-size: 11px;
    color: #888888;
    margin-bottom: 8px;
}

.guest-actions {
    display: flex;
    gap: 6px;
}

.guest-btn {
    flex: 1;
    text-align: center;
    font-size: 11.5px;
    padding: 7px 10px;
    border-radius: 6px;
    border: 1px solid #e0e0e0;
    color: #23282C;
    text-decoration: none;
    background: white;
    font-weight: 500;
}

.guest-btn:hover {
    border-color: #23282C;
}

.guest-btn--primary {
    background: #23282C;
    color: white;
    border-color: #23282C;
}

.guest-btn--primary:hover {
    background: #000;
    border-color: #000;
}
</style>
